import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a4b3c] text-white pt-16 pb-8 border-t-4 border-[#c99b36]">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center gap-2 mb-6">
              <img 
                src="/images/talclogo.jpg"
                alt="TALC Logo"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-white/80 leading-relaxed mb-6">
              Soluções contábeis completas para o crescimento sustentável do seu negócio.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#c99b36] rounded-full flex items-center justify-center transition-all duration-200" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/assessoriatalc/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-white/10 hover:bg-[#c99b36] rounded-full flex items-center justify-center transition-all duration-200" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="w-10 h-10 bg-white/10 hover:bg-[#c99b36] rounded-full flex items-center justify-center transition-all duration-200" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h3 className="text-xl font-bold mb-6 text-[#c99b36]">Links Rápidos</h3>
            <ul className="space-y-3">
              {['Início', 'Serviços', 'Sobre', 'Recuperação', 'Depoimentos', 'Agendar'].map((item, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase().replace('ç', 'c').replace('ã', 'a'))}
                    className="text-white/80 hover:text-[#c99b36] transition-colors duration-200"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h3 className="text-xl font-bold mb-6 text-[#c99b36]">Contato</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="text-[#c99b36] w-5 h-5 flex-shrink-0 mt-1" />
                <span className="text-white/80">Santo Ângelo, RS</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="text-[#c99b36] w-5 h-5 flex-shrink-0 mt-1" />
                <a href="tel:+5555984328501" className="text-white/80 hover:text-[#c99b36] transition-colors duration-200">(55) 98432-8501</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="text-[#c99b36] w-5 h-5 flex-shrink-0 mt-1" />
                <a href="mailto:admtalc@gmail.com" className="text-white/80 hover:text-[#c99b36] transition-colors duration-200">admtalc@gmail.com</a>
              </li>
            </ul>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            <h3 className="text-xl font-bold mb-6 text-[#c99b36]">Horário de Atendimento</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Clock className="text-[#c99b36] w-5 h-5 flex-shrink-0 mt-1" />
                <div className="text-white/80">
                  <p className="font-semibold">Segunda a Sexta</p>
                  <p>08:30 - 12:00</p>
                  <p>13:30 - 18:00</p>
                </div>
              </li>
            </ul>
          </motion.div>
        </div>

        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-white/60">
            © {currentYear} TALC Assessoria Contábil. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;